import { createSignal, Show, type Component } from "solid-js";
import SaveUpload, { UploadState } from "./components/SaveUpload";
import Editor from "./components/Editor";
import { getSeenPlayers, setSeenPlayers } from "./lib/persistentData";

const App: Component = () => {
    const [uploadState, setUploadState] = createSignal<UploadState | undefined>()

    const onUpload = (state: UploadState) => {
        setUploadState(state)
        const existingPlayers = getSeenPlayers()
        const newPlayers = Object.entries(state.state.data.playerNames.value).filter(([id]) => !existingPlayers.some(existing => existing.id == id))
        setSeenPlayers([...existingPlayers, ...newPlayers.map(([id, name]) => ({id, name}))])
    }

    return <>
        <div class="divider"/>
        <SaveUpload onUpload={onUpload}/>
        <Show when={uploadState()}>
            {(state) => (<>
                <div class="divider"/>
                <Editor state={state()}/>
            </>)}
        </Show>
    </>
};

export default App
